import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { UserRequest } from '../models/userRequest';
import { PaginationFeaturesDto } from '../models/paginationfeaturesdto';
import { AppConfigService } from './core/appConfig.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private url_user_list = '';
  private url_roles_list = '';
  private url_create_user = '';
  private url_update_user = '';
  private url_delete_user = '';
  private url_find_name_idp = '';
  private url_validate_user_init = '';

  constructor(private http: HttpClient, private configService: AppConfigService) { 
  this.url_user_list = this.configService.apiUrl + '/configuration/user/listAll';
  this.url_roles_list = this.configService.apiUrl + '/configuration/user/getAll/role-master/';
  this.url_create_user = this.configService.apiUrl + '/configuration/user/be-create';
  this.url_update_user = this.configService.apiUrl + '/configuration/user/be-update/';
  this.url_delete_user = this.configService.apiUrl + '/configuration/user/be-delete/';
  this.url_find_name_idp = this.configService.apiUrl + '/configuration/user/';
  this.url_validate_user_init = this.configService.apiUrl + '/validate/user/';
  }

  /**
   * Función encargada de listar todos los usuarios autorizados dentro de la aplicación
   * @returns 
   */
  getListUser(pageRequest: PaginationFeaturesDto): Observable<any> {
    const params = new HttpParams()
      .set('page', pageRequest.page)
      .set('sizePage', pageRequest.sizePage)
      .set('orderField', pageRequest.orderField)
      .set('order', pageRequest.order);
    return this.http.get<any>(this.url_user_list, { params });
  }

  getListRolesMaster(): Observable<any> {
    return this.http.get<any>(this.url_roles_list + false);
  }

  createUserAuthoriation(userRequest: UserRequest): Observable<any> {
    return this.http.post<any>(this.url_create_user, userRequest.user);
  }

  updateUserAuthoriation(userRequest: UserRequest, updateRol: boolean): Observable<any> {
    return this.http.put<any>(this.url_update_user + updateRol, userRequest.user);
  }

  deleteUser(idUserTariff: number): Observable<any> {
    return this.http.delete<any>(this.url_delete_user + idUserTariff);
  }

  findByNameOrIdp(event: string): Observable<any> {
    return this.http.get<any>(this.url_find_name_idp + event);
  }

  validateUserIniti(idpUser: number): Observable<any> {
    return this.http.get<any>(this.url_validate_user_init + idpUser);
  }

}



